/** @format */

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DataPointValue } from "src/app/models/data-point-value.model";
import { Logsheet } from "src/app/models/logsheet.model";
import { environment } from "src/environments/environment";
import * as moment from "moment";
import "moment-timezone";

@Injectable({
  providedIn: "root",
})
export class LogSheetFormService {
  baseUrl: string = environment.apiUrl;
  constructor(private http: HttpClient) {}
  saveLogSheet(logSheetId: number, data: any[], isSaving: boolean, entryId?: number) {
    const utc = new Date();
    const now = new Date(utc.getTime() - utc.getTimezoneOffset() * 60000).toISOString().slice(0, -1);

    const payload = {
      MultipleDataPointLogs: [
        {
          LogSheetId: logSheetId,
          DataPointIds: data.map((dp) => ({
            DataPointId: dp.dataPointId,
            Value: dp.value,
            Note: dp.note || "",
          })),
          IsSaving: isSaving,
          LastModifiedDate: now,
          EntryID: entryId || 1,
        },
      ],
      IsSaving: isSaving,
      LastModifiedDate: now,
    };

    return this.http.post(
      `${this.baseUrl}/DataPointLog/${logSheetId}`,
      payload
    );
  }

  // Save multiple entries in a single API call (for dynamic forms with multiple entries)
  saveMultipleEntries(logSheetId: number, sections: any[], isSaving: boolean) {
    const utc = new Date();
    const now = new Date(utc.getTime() - utc.getTimezoneOffset() * 60000).toISOString().slice(0, -1);

    const payload = {
      MultipleDataPointLogs: sections.map((section) => ({
        LogSheetId: logSheetId,
        DataPointIds: section.dataPointValues.map((dp: any) => ({
          DataPointId: dp.dataPointId,
          Value: dp.value,
          Note: dp.note || "",
        })),
        IsSaving: isSaving,
        LastModifiedDate: now,
        EntryID: section.entryId || null,
      })),
      IsSaving: isSaving,
      LastModifiedDate: now,
    };

    return this.http.post(
      `${this.baseUrl}/DataPointLog/${logSheetId}`,
      payload
    );
  }

  saveMultipleTempEntries(logSheetId: number, sections: any[], isSaving: boolean) {
    const now = new Date().toISOString();

    const payload = {
      MultipleDataPointLogs: sections.map((section) => ({
        LogSheetId: logSheetId,
        DataPointIds: section.dataPointValues.map((dp: any) => ({
          DataPointId: dp.dataPointId,
          Value: dp.value,
          Note: dp.note || "",
        })),
        IsSaving: isSaving,
        LastModifiedDate: now,
        EntryID: section.entryId || null,
      })),
      IsSaving: isSaving,
      LastModifiedDate: now,
    };

    return this.http.post(
      `${this.baseUrl}/DataPointLog/temp-form/${logSheetId}`,
      payload
    );
  }

  deleteEntry(logSheetId: number, entryId: number) {
    return this.http.delete(
      `${this.baseUrl}/LogSheetEntry/${logSheetId}/${entryId}`
    );
  }

  retrieveLogSheetVersions(id: number): Observable<Logsheet[]> {
    return this.http.get<Logsheet[]>(
      this.baseUrl + `/logsheet/logs-history?logsheetId=${id}`
    );
  }
}
